import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel";

const sliderData = {
  loop: true,
  margin: 1,
  nav: false,
  responsiveClass: true,
  items: 1,
  dots: false,
  autoplay: false,
  autoplayTimeout: 4000,
  smartSpeed: 3000,
  animateOut: "fadeOut",
  animateIn: "fadeIn",
}

let owlHero = $("#hero__slider");
owlHero.owlCarousel({
  ...sliderData
});

let owlHeroText = $("#hero__slider__text");
owlHeroText.owlCarousel({
  ...sliderData,
  animateOut: "fadeOut",
  animateIn: "fadeIn",
  mouseDrag: false,
  touchDrag: false
});

owlHero.on("changed.owl.carousel", function (event) {
  setTimeout(function() { playVideo(); }, 1000);
});

owlHero.on("dragged.owl.carousel", function (e) {
  pauseSlider();
  stopVideo();
  if(e.relatedTarget._drag.direction === 'left') {
    owlHeroText.trigger("next.owl.carousel");
  } else {
    owlHeroText.trigger("prev.owl.carousel");
  }
  setTimeout(function() { playSlider();}, 100);
});

$(".hero__prev").on("click", function () {
  owlHero.trigger("prev.owl.carousel");
  owlHeroText.trigger("prev.owl.carousel");
  stopVideo();
  pauseSlider();
  setTimeout(function() { playSlider();}, 100);
});

$(".hero__next").on("click", function () {
  owlHero.trigger("next.owl.carousel");
  owlHeroText.trigger("next.owl.carousel");
  stopVideo();
  pauseSlider();
  setTimeout(function() { playSlider();}, 100);
});

function pauseSlider()  {
  owlHero.trigger("stop.owl.autoplay");
  owlHeroText.trigger("stop.owl.autoplay");
}

function playSlider() {
  owlHero.trigger("play.owl.autoplay");
  owlHeroText.trigger("play.owl.autoplay");
}

function playVideo() {
  const video = owlHero.find(".owl-item.active").find("video");
  pauseSlider();
  if (!!video.length) {
    video[0].play();
  } else {
    playSlider();
  }
}

function stopVideo() {
  const video = owlHero.find("video");
  if (!!video.length) {
    video.each((index, element) => {
      video[index].currentTime = 0;
    });
  }
}

$(window).on("load", function () {
  $("#hero__slider .top_video").each((item) => {
    $("#hero__slider .top_video")[item].addEventListener(
      "ended",
      function () {
        stopVideo();
        setTimeout(() => {
          playSlider();
        }, 100);
      },
      false
    );
  });
  playVideo();
});